export function build_message_blocks(text, is_assistant, get_absolute_download_href) {
  const message_text = String(text || "");
  if (!message_text || !is_assistant) return create_text_blocks(message_text);

  return message_text.split("\n").map((line) => create_message_block(line, get_absolute_download_href));
}

function create_text_blocks(text) {
  return String(text || "").split("\n").map((line) => ({
    type: "text",
    parts: [{ type: "text", text: line }],
  }));
}

function create_message_block(line, get_absolute_download_href) {
  const heading_match = get_heading_match(line);
  if (heading_match) return ({ type: "heading", text: heading_match[1] });

  const action_match = line.match(/^(\s*\d+\.\s+)\*\*([^*\n]+)\*\*(.*)$/);
  if (action_match) {
    const parts = [
      { type: "list_marker", text: action_match[1] },
      { type: "action_title", text: action_match[2] },
    ].concat(create_inline_parts(action_match[3], get_absolute_download_href));

    return ({
      type: "text",
      parts,
    });
  }

  return ({
    type: "text",
    parts: create_inline_parts(line, get_absolute_download_href),
  });
}

function get_heading_match(line) {
  return line.match(/^\s*#{1,6}\s+(.+?)\s*$/)
    || line.match(/^\s*\*\*([^*\n]+)\*\*\s*$/)
    || line.match(/^\s*((?:Key Finding|Key Findings|Why It Matters|Recommended Actions|Recommendation|Recommendations|Next Steps|Summary|Note):)\s*$/i);
}

function create_inline_parts(text, get_absolute_download_href) {
  const parts = [];
  const pattern = /\[([^\]]+)\]\s*\(([^)<>\s]+\/pdf\/download\/?)\)|\*\*([^*\n]+)\*\*|(^|\s)\*([^*\n]+)\*/gi;
  let last_index = 0;
  let match = pattern.exec(text);

  while (match !== null) {
    append_text_part(parts, text.slice(last_index, match.index));
    parts.push(...create_match_parts(match, get_absolute_download_href));
    last_index = pattern.lastIndex;
    match = pattern.exec(text);
  }

  append_text_part(parts, text.slice(last_index));
  return parts.length ? parts : [{ type: "text", text }];
}

function append_text_part(parts, text) {
  if (text) parts.push({ type: "text", text });
}

function create_match_parts(match, get_absolute_download_href) {
  if (match[1]) return [create_document_part(match, get_absolute_download_href)];
  if (match[3]) return [{ type: "strong", text: match[3] }];
  return create_emphasis_parts(match);
}

function create_document_part(match, get_absolute_download_href) {
  const href = get_absolute_download_href(match[2]);
  if (!href) return ({ type: "text", text: match[0] });
  return ({
    type: "document",
    text: match[1] || "Download report PDF",
    href,
  });
}

function create_emphasis_parts(match) {
  const emphasis_part = { type: "emphasis", text: match[5] };
  return match[4]
    ? [{ type: "text", text: match[4] }, emphasis_part]
    : [emphasis_part];
}
